import React from "react";

const MoreOptions = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <ellipse className="u_fill" cx={5.097} cy={5.038} rx={3.097} ry={3.038} fill={fill} />
        <ellipse className="u_fill" cx={5.097} cy={18} rx={3.097} ry={3.038} fill={fill} />
        <ellipse className="u_fill" cx={5.097} cy={30.962} rx={3.097} ry={3.038} fill={fill} />
        <ellipse className="u_fill" cx={17.897} cy={5.038} rx={3.097} ry={3.038} fill={fill} />
        <ellipse className="u_fill" cx={17.897} cy={18} rx={3.097} ry={3.038} fill={fill} />
        <ellipse className="u_fill" cx={17.897} cy={30.962} rx={3.097} ry={3.038} fill={fill} />
        <ellipse className="u_fill" cx={30.903} cy={5.038} rx={3.097} ry={3.038} fill={fill} />
        <ellipse className="u_fill" cx={30.903} cy={18} rx={3.097} ry={3.038} fill={fill} />
        <ellipse className="u_fill" cx={30.903} cy={30.962} rx={3.097} ry={3.038} fill={fill} />
    </svg>
);

export default MoreOptions;
